/** ----------------------------------------
    Node Modules
 ---------------------------------------- */

import CircleType from 'circletype';
import anime from 'animejs';

/** ----------------------------------------
    Transitions
 ---------------------------------------- */

const fadeIn = (el, duration = 750, delay = 1000) => {
    return new Promise((resolve) => {
        anime({
            targets: el,
            opacity: [0, 1],
            duration: duration,
            delay: delay,
            easing: 'easeInQuart',
            complete: () => resolve()
        });
    });
};

const rotate = (el, duration = 10000) => {
    return anime({
        targets: el,
        rotate: [0, 360],
        loop: true,
        duration: duration,
        easing: 'linear'
    });
};

/** ----------------------------------------
    Create Element
 ---------------------------------------- */

const createEl = settings => {
    const tag = settings.tag || 'div';
    const el = document.createElement(tag);

    if(settings.class)
        el.setAttribute('class', settings.class.replace('.', ''));

    const parent = document.querySelector(settings.parent);

    return {
        element: el,
        parent: parent
    };
};

/** ----------------------------------------
    Circle
 ---------------------------------------- */

const createCircle = (content, settings) => {

    /** ----------------------------------------
        Create Element
     ---------------------------------------- */

    const size = content.length * 2.75;
    const item = createEl(settings);
    item.element.textContent = content;

    /** ----------------------------------------
        Add Circular Text
     ---------------------------------------- */

    setTimeout(() => {
        const circleType = new CircleType(item.element);
        circleType.radius(size);
    }, 50);

    /** ----------------------------------------
        Append
     ---------------------------------------- */

    item.parent.appendChild(item.element);

    /** ----------------------------------------
        Animate Element
     ---------------------------------------- */

    fadeIn(settings.class);
    rotate(settings.class, 10000);

};

/** ----------------------------------------
     Exports
 ---------------------------------------- */

export {
    createCircle
};